import { h } from 'preact';

const ComingSoon = (props) => {
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" {...props}>
			<g transform="translate(1.000000, 1.000000)">
				<path class="st0" fill-rule="evenodd" clip-rule="evenodd" fill-opacity="0.3" d="M7.555,13H2c-0.551,0-1-0.449-1-1V6h12v1.555c0.378,0.22,0.714,0.497,1,0.825V3
					c0-1.105-0.895-2-2-2h-1V0.5C11,0.224,10.776,0,10.5,0S10,0.224,10,0.5V1H4V0.5C4,0.224,3.776,0,3.5,0S3,0.224,3,0.5V1H2
					C0.895,1,0,1.895,0,3v9c0,1.105,0.895,2,2,2h6.38C8.052,13.714,7.775,13.378,7.555,13z M1,3c0-0.551,0.449-1,1-1h1v0.5
					C3,2.776,3.224,3,3.5,3S4,2.776,4,2.5V2h6v0.5C10,2.776,10.224,3,10.5,3S11,2.776,11,2.5V2h1c0.551,0,1,0.449,1,1v2H1V3z"/>
				<path class="st1" fill-rule="evenodd" clip-rule="evenodd" d="M11,7c2.209,0,4,1.791,4,4s-1.791,4-4,4s-4-1.791-4-4S8.791,7,11,7z M11,8
					c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S12.657,8,11,8z M11,8.5c0.276,0,0.5,0.224,0.5,0.5v1.5h1
					c0.276,0,0.5,0.224,0.5,0.5s-0.224,0.5-0.5,0.5H11c-0.276,0-0.5-0.224-0.5-0.5V9C10.5,8.724,10.724,8.5,11,8.5z"/>
			</g>
		</svg>
	);
};

export default ComingSoon;
